import React, { Fragment, useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./../CustomedFields/FormikControl";
import { useParams } from "react-router-dom";
import CustomerAtMeasurementPage from "./CustomerAtMeasurementPage";
import measurementSettingsServices from "./../../services/measurementSettingsServices";
import DDLmeasurementSettings from "../Measurement/DDLmeasurementSettings";
import AddEditSingleMeasurement from "./AddEditSingleMeasurement";

const CustomerMeasurement = (props) => {
  // customerGUID
  const [selectedMeasurementSettings, setSelectedMeasurementSettings] =
    useState(0);
  const [selectedMeasurementSettingsName, setSelectedMeasurementSettingsName] =
    useState("");
  const [selectedProductItemGUID, setSelectedProductItemGUID] = useState("");
  const [selectedProductItemName, setSelectedProductItemName] = useState("");
  const [showAddEditSingle, setShowAddEditSingle] = useState(false);

  //(**) On product Item for Measurement select

  const onProductItemSelect = (
    selectedProductItemGIUD,
    selectedProductItemName,
    slectedID,
    selectedValue
  ) => {
    //alert(slectedID + ",vv " + selectedValue);
    setSelectedProductItemGUID(selectedProductItemGIUD);
    setSelectedMeasurementSettings(slectedID);
    setSelectedMeasurementSettingsName(selectedValue);
    setSelectedProductItemName(selectedProductItemName);
  };

  const AddNewMeasurement = () => {
    // alert(selectedMeasurementSettings);
    setShowAddEditSingle(true);
  };

  return (
    <Fragment>
      CustomerMeasurementList
      <div className="row">
        <div className="col-lg-11 col-xl-12">
          {/* Code BLOCK: Select Type DDL and add new */}
          <div className="card card-custom">
            <div className="card-body card-low-margin">
              <div className="d-flex align-items-center">
                {/* <ul className="mb-0 form-profile__icons">
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-user"></i>
                      </button>
                    </li>
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-paper-plane"></i>
                      </button>
                    </li>
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-camera"></i>
                      </button>
                    </li>
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-smile"></i>
                      </button>
                    </li>
                  </ul> */}
                <div style={{ width: "100%" }}>
                  <div
                    className="col"
                    style={{ width: "200px", float: "left" }}
                  >
                    <DDLmeasurementSettings
                      ddlOnSelectFunction={onProductItemSelect}
                    />
                    {/* <div className="dropdown custom-dropdown">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        data-toggle="dropdown"
                      >
                        Select Product Item Measurement{" "}
                        <i className="fa fa-angle-down m-l-5"></i>
                      </button>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="#">
                          Last 1 Month
                        </a>{" "}
                        <a className="dropdown-item" href="#">
                          Last 6 Month
                        </a>{" "}
                        <a className="dropdown-item" href="#">
                          Last 10 Month
                        </a>
                      </div>
                    </div> */}
                  </div>
                  <button
                    style={{ float: "right" }}
                    className="btn btn-primary px-3 ml-4"
                    onClick={AddNewMeasurement}
                  >
                    Add New Measurement
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* CODE Block : add Edit single */}
          {showAddEditSingle && (
            <AddEditSingleMeasurement
              customerGUID={props.customerGUID}
              selectedProductItemGUID={selectedProductItemGUID}
              productItemName={selectedProductItemName}
              settingsName={selectedMeasurementSettingsName}
              settingsID={selectedMeasurementSettings}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default CustomerMeasurement;
